var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999V9.00121C32 7.33773 32 6.50599 31.6496 5.99485C31.3434 5.54826 30.8693 5.24489 30.3355 5.15406C29.7246 5.0501 28.9694 5.39865 27.459 6.09574L9.71803 14.2839C8.37101 14.9056 7.6975 15.2164 7.20421 15.6985C6.76812 16.1247 6.43523 16.645 6.23101 17.2196C6 17.8695 6 18.6113 6 20.0948V29.9999M33 28.9999H33.02M6 22.3999L6 35.5999C6 37.8401 6 38.9602 6.43597 39.8159C6.81947 40.5685 7.43139 41.1804 8.18404 41.5639C9.03968 41.9999 10.1598 41.9999 12.4 41.9999H35.6C37.8402 41.9999 38.9603 41.9999 39.816 41.5639C40.5686 41.1804 41.1805 40.5685 41.564 39.8159C42 38.9602 42 37.8401 42 35.5999V22.3999C42 20.1597 42 19.0396 41.564 18.1839C41.1805 17.4313 40.5686 16.8194 39.816 16.4359C38.9603 15.9999 37.8402 15.9999 35.6 15.9999L12.4 15.9999C10.1598 15.9999 9.03969 15.9999 8.18404 16.4359C7.43139 16.8194 6.81947 17.4313 6.43597 18.1839C6 19.0396 6 20.1597 6 22.3999ZM34 28.9999C34 29.5522 33.5523 29.9999 33 29.9999C32.4477 29.9999 32 29.5522 32 28.9999C32 28.4476 32.4477 27.9999 33 27.9999C33.5523 27.9999 34 28.4476 34 28.9999Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB5);
export default __webpack_public_path__ + "static/media/b5.bef07bb4c7bc352f4de5b4de3987b8c0.svg";
export { ForwardRef as ReactComponent };